import { Chip } from '@mui/material';
import { OrderType } from '../interfaces/delivery-company/orders';
import { add, CURRENCY, displayMoney, minus, Money } from './money';
import { TurnedInNot } from '@mui/icons-material';
import { displayDeliveryRule } from '../components/delivery-company-components/merchants/delivery-charge-rules/utils';
import Decimal from 'decimal.js';

export const calculateExtraDeliveryCharges = (order: OrderType): Money[] => {
  const labels = order.labels ?? [];
  const rules = order.delivery_fee_rules ?? [];
  console.log("order = ", order)

  let result: Money[] = [];
  labels.forEach((label) => (result = add(result, label.extra_delivery_fee)));
  rules.forEach((rule) => (result = add(result, [[CURRENCY.USD,rule.delta_charge]])))
  if (order.critical_order_surcharge) result = add(result, order.critical_order_surcharge.amount)
  return result;
};

export const splitExtraCharges = (order: OrderType): {
  id: string;
  amount: string;
  reason: JSX.Element;
}[] => {
  const result = []
  if (order.labels)  {
    result.push(...order.labels.map(item=>({
      id: `label-${item.id}`,
      amount: displayMoney(item.extra_delivery_fee, true),
      reason: <Chip
          icon={<TurnedInNot />}
          label={`${item.key}:${item.value}`}
        />
    })))
  }

  if (order.delivery_fee_rules)  {
    result.push(...order.delivery_fee_rules.map(item=>({
      id: `rule-${item.id}`,
      amount: displayMoney([[CURRENCY.USD, item.delta_charge]], true),
      reason: <>{displayDeliveryRule(item)}</>
    })))
  }

  if (order.critical_order_surcharge) 
    result.push({
      id: `critical-order-surcharge`,
      amount: displayMoney(order.critical_order_surcharge.amount, true),
      reason: <>Critical Order</>
    });

  return result
}

export const calculateBaseDeliveryFee = (order: OrderType): Money[] => {
  return minus(order.delivery_fee, calculateExtraDeliveryCharges(order));
};
// Helper function to render package details rows
export const renderPackageDetailsRows = (order: OrderType) => {
  if (
    !order.packages_metadata ||
    order.packages_metadata.length === 0
  )
    return [];
  return order.packages_metadata
    .map((metadata, index) => {
      const desc = metadata.description || '';
      if (
        desc &&
        desc.trim() !== '' &&
        desc.toLowerCase() !== 'no description'
      ) {
        return { pkgNum: (index + 1).toString(), desc };
      }
      return null;
    })
    .filter(Boolean) as { pkgNum: string; desc: string }[];
};

export const getPackageDescription = (
  order: OrderType,
  packageNumber: number
): string => {
  if (
    order &&
    order.packages_metadata &&
    order.packages_metadata.length >= packageNumber
  ) {
    return (
      order.packages_metadata[packageNumber-1]?.description ?? ''
    );
  }
  return 'No description';
};

export const updateDeliveryFee = (
  order: OrderType,
  base_delivery_fee: Money[]
): OrderType => {
  return {
    ...order,
    delivery_fee: add(base_delivery_fee, calculateExtraDeliveryCharges(order)),
  };
};
